import { Box, BoxProps } from '@mui/material';
import React from 'react';

export default function Col(props: BoxProps) {
  return (
    <Box
      {...props}
      sx={{ display: 'flex', flexDirection: 'column', ...props.sx }}
    ></Box>
  );
}
